/** Feature flags. Flip here (or via VITE_* env) when the client decides; nothing else needs to change. */
export const features = {
  /** user accounts (phase 5) */
  auth: import.meta.env.VITE_FEATURE_AUTH === 'true',
  /** paid access: codes / subscriptions / tokens (phase 6) */
  billing: import.meta.env.VITE_FEATURE_BILLING === 'true',
  /** sound cues available in settings */
  sound: true,
} as const;
